import { module } from 'modujs';
import { gsap } from 'gsap';
import { onRAF } from '../utils/onRAF';
import { cover } from '../utils/canvas';

export default class extends module {
	constructor(m) {
			super(m);
	}

	init() {
		this.video = this.el;

		if(window.isMobile) {
			this.video.src = '';
		}

		// get module the synchronized video
		let id = this.el.getAttribute('data-module-synchronized-video');
		
		this.canvases = document.querySelectorAll(`[data-synchronized-canvas="${id}"]`);

		this.ctxs = [];
		this.canvases.forEach(canvas => {
			this.ctxs.push(canvas.getContext('2d'));
		});

		this.resizeDebounce();

		this.unregisterRAF = onRAF(() => this.updateCanvas());

		this.bindResize = this.resize.bind(this);
		window.addEventListener('resize', this.bindResize);

		this.bindCanplaythrough = this.canplaythrough.bind(this);
		this.video.addEventListener('canplaythrough', this.bindCanplaythrough);
	}

	canplaythrough(e) {
		this.resizeDebounce();
		this.video.removeEventListener('canplaythrough', this.bindCanplaythrough);

	}
	
	trigger(e) {
		if(window.isMobile) return;

		if(e.mode == 'enter') {

		}
	}

	updateCanvas() {
		this.ctxs.forEach((ctx, idx) => {			
			if(this.canvases[idx].classList.contains('is-inview') ||
				this.canvases[idx].classList.contains('is-persistant')
			){ 	
				const {
					offsetX, 
					offsetY, 
					width, 
					height
				} = cover(this.bcr.width, this.bcr.height, this.videoBCR.width, this.videoBCR.height)

				ctx.drawImage(this.video,offsetX,offsetY,width,height);
			}
		});
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.bcr = this.canvases[0].getBoundingClientRect();
		this.videoBCR = this.el.getBoundingClientRect();
		
		this.canvases.forEach(canvas => {
			canvas.width = this.bcr.width;
			canvas.height = this.bcr.height;
		})
	}

	destroy() {
		if(!window.isMobile) {
			this.unregisterRAF();
		}

		this.video.removeEventListener('canplaythrough', this.bindCanplaythrough);
		window.removeEventListener('resize', this.bindResize);

	}
}
